import { ApiService } from '../../../shared/service/Apiservice';
import { environment } from '../../../shared/enviroment/environment';
import { ApiResponse, UpdateProfilePayload } from '../dto/Profile.dto';

export class ProfileService {
  private apiRootServer = environment.api.apiRootServer;

  constructor(private apiService: ApiService) {}

  async getUserProfile(): Promise<ApiResponse> {
    return this.apiService.getRequest('auth/me', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async updateUserProfile(payload: UpdateProfilePayload): Promise<ApiResponse> {
    if (!payload) {
      throw new Error('Profile data is required for updating');
    }
    const { userId, ...updateData } = payload;
    return this.apiService.putRequest('auth/update-details', updateData, {
      apiRoot: this.apiRootServer,
    });
  }

  async GetUserOrder(): Promise<any> {
    return this.apiService.getRequest(`orders`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async GetUserOrderById(orderId: string): Promise<any> {
    if (!orderId) throw new Error('orderId is required');
    return this.apiService.getRequest(`orders/${orderId}`, {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async cancelOrder(orderId: string, reason: string, customReason?: string): Promise<any> {
    if (!orderId) throw new Error('orderId is required');
    if (!reason) throw new Error('Cancellation reason is required');
    
    const payload: any = { reason };
    if (customReason) {
      payload.customReason = customReason;
    }
    
    return this.apiService.patchRequest(`orders/${orderId}/cancel`, payload, {
      apiRoot: this.apiRootServer,
    });
  }
  async requestAccountDeletion(reason: string, additionalComments?: string): Promise<any> {
    if (!reason) {
      throw new Error('Reason for deletion is required');
    }
    
    const payload = {
      reason,
      additionalComments: additionalComments || undefined
    };
    
    return this.apiService.postRequest('users/account/request-deletion', payload, {
      apiRoot: this.apiRootServer,
    });
  }

  async getAccountDeletionStatus(): Promise<any> {
    return this.apiService.getRequest('users/account/deletion-status', {}, {
      apiRoot: this.apiRootServer,
    });
  }

  async cancelAccountDeletion(): Promise<any> {
    return this.apiService.postRequest('users/account/cancel-deletion', {}, {
      apiRoot: this.apiRootServer,
    });
  }
}